export const GEOLOCATION_ERROR =
  'You must be within the refuge to use the navigation features.';
export const LOCATION_PERMISSION_ERROR =
  'You must share your location to use the navigation features.';
export const ERROR = 'An error has occurred please try again later.';
